import { ViewType, ViewObject } from '../base';

import { dataService } from '../../data';
import { AccountInvoice } from '../objects/accountinvoice';

import { PayAccountView } from './payaccount';

/****************************/
/* CLASS VIEW               */
/****************************/

export class _AccountInvoiceView extends ViewObject<AccountInvoice> {

    /**********************************/
    /* VIEWOBJECT IMPLEMENTATION      */
    /**********************************/

    private get accountinvoice(): AccountInvoice {
        return this.object;
    }

    constructor(object: AccountInvoice, data: dataService){
        super(object, data);
    }

    override OnDestroy(): void {
        super.OnDestroy();
    }

    /**********************************/
    /* VIEW MANAGED INFORMATION       */
    /**********************************/

    private RefreshView(targets: string[]){
        if (targets.includes('ACCOUNTINVOICE')){
            this.DoRefreshView();
        }

        if (targets.includes('PAYACCOUNT')){
            this.DoRefreshView();
        }

        if (targets.includes('TICKETBAI')){
            this.DoRefreshView();
        }

        if (targets.includes('VERIFACTU')){
            this.DoRefreshView();
        }
    }

    /**********************************/
    /* CHILDREN REGISTRATION          */
    /**********************************/

    override doRegister(): void{
        const weakref = new WeakRef(this);

        for (const _subsription of this._subscriptions){
            _subsription.unsubscribe();
        }
        this._subscriptions = [];

        this._subscriptions.push(
            this.accountinvoice.OnChildChanged.subscribe(() => {
                const self = weakref.deref();
                if (self) self.doRegister();
            })
        );

        this._subscriptions.push(
            this.accountinvoice.OnRefresh.subscribe(
            (targets: string[]) => {
                const self = weakref.deref();
                if (self){
                    self.RefreshView(targets);
                }
            })
        );

        const _account = this.accountinvoice.account;
        if (_account){
            this._subscriptions.push(
                _account.OnRefresh.subscribe(
                (targets: string[]) => {
                    const self = weakref.deref();
                    if (self){
                        self.RefreshView(targets);
                    }
                })
            );
        }
    }

    /**********************************/
    /* ACTIVE CHILDREN INFORMATION    */
    /**********************************/

    get account(): PayAccountView | null {
        return this.data.alives.get(this.accountinvoice.account) as PayAccountView;
    }
}

/****************************/
/* PROXY VIEW               */
/****************************/

export type AccountInvoiceView = ViewType<_AccountInvoiceView, AccountInvoice>;

export function AccountInvoiceViewProxy(object: AccountInvoice, data: dataService): AccountInvoiceView {
    return new _AccountInvoiceView(object, data).Proxy as AccountInvoiceView;
}
